<template>
  <div class="question-show">
    <!-- 题目标题 -->
    <div class="q-title"
         :class="answerResultClass(questionItem)">
      <div class="title-text"
           v-show="questionItem.questionTypeNm">[{{questionItem.questionTypeNm}}]</div>
      <div v-html="questionItem.title"></div>
    </div>

    <!-- 题型 START -->
    <!-- 单选 -->
    <template v-if="questionItem.questionType == 1">
      <div class="q-content">
        <!-- 学生作答 -->
        <template v-if="action === 'do'">
          <van-radio-group :key="`${questionItem.id}_do`"
                           v-model="questionItem.correct">
            <van-radio v-for="item in questionItem.items"
                       :key="item.prefix"
                       :name="item.prefix">
              <span class="question-prefix">{{item.prefix}}.</span>
              <span v-html="item.content"
                    class="q-item-span-content"></span>
            </van-radio>
          </van-radio-group>
        </template>

        <!-- 查看 -->
        <template v-else>
          <van-radio-group :key="`${questionItem.id}_view`"
                           v-model="questionItem.answer.stuAnswer"
                           disabled>
            <van-radio v-for="item in questionItem.items"
                       :key="item.prefix"
                       :name="item.prefix">
              <span class="question-prefix">{{item.prefix}}.</span>
              <span v-html="item.content"
                    class="q-item-span-content"></span>
            </van-radio>
          </van-radio-group>
        </template>
      </div>
    </template>

    <!-- 多选 -->
    <template v-if="questionItem.questionType == 2">
      <div class="q-content">
        <!-- 学生作答 -->
        <template v-if="action === 'do'">
          <van-checkbox-group :key="`${questionItem.id}_do`"
                              v-model="questionItem.correctArray">
            <van-checkbox v-for="item in questionItem.items"
                          :name="item.prefix"
                          :key="item.prefix"
                          shape="square">
              <span class="question-prefix">{{item.prefix}}.</span>
              <span v-html="item.content"
                    class="q-item-span-content"></span>
            </van-checkbox>
          </van-checkbox-group>
        </template>

        <!-- 查看 -->
        <template v-else>
          <van-checkbox-group :key="`${questionItem.id}_view`"
                              v-model="questionItem.answer.stuAnswer"
                              disabled>
            <van-checkbox v-for="item in questionItem.items"
                          :name="item.prefix"
                          :key="item.prefix"
                          shape="square">
              <span class="question-prefix">{{item.prefix}}.</span>
              <span v-html="item.content"
                    class="q-item-span-content"></span>
            </van-checkbox>
          </van-checkbox-group>
        </template>
      </div>
    </template>

    <!-- 判断 -->
    <template v-if="questionItem.questionType == 3">
      <div class="q-content">
        <!-- 学生作答 -->
        <template v-if="action === 'do'">
          <van-radio-group :key="`${questionItem.id}_do`"
                           v-model="questionItem.correct">
            <van-radio v-for="item in questionItem.items"
                       :key="item.prefix"
                       :name="item.prefix">
              <span class="question-prefix">{{item.prefix}}.</span>
              <span v-html="item.content"
                    class="q-item-span-content panduan"></span>
            </van-radio>
          </van-radio-group>
        </template>

        <!-- 查看 -->
        <template v-else>
          <van-radio-group :key="`${questionItem.id}_view`"
                           v-model="questionItem.answer.stuAnswer"
                           disabled>
            <van-radio v-for="item in questionItem.items"
                       :key="item.prefix"
                       :name="item.prefix">
              <span class="question-prefix">{{item.prefix}}.</span>
              <span v-html="item.content"
                    class="q-item-span-content panduan"></span>
            </van-radio>
          </van-radio-group>
        </template>
      </div>
    </template>

    <!-- 填空 -->
    <template v-if="questionItem.questionType == 4">
      <div class="q-content">
        <div :key="item.prefix"
             v-for="item in questionItem.items"
             class="inp-box van-hairline--bottom">
          <template v-if="action === 'do'">
            <van-field :label="`${item.prefix}.`"
                       :border="true"
                       :placeholder="`请输入填空${item.prefix}`"
                       v-model="questionItem.correctArray[item.prefix-1]" />
          </template>
          <template v-else>
            <van-field :label="`${item.prefix}.`"
                       :border="true"
                       :placeholder="`请输入填空${item.prefix}`"
                       disabled
                       v-model="questionItem.answer.stuAnswer[item.prefix-1]" />
          </template>
        </div>
      </div>
    </template>

    <!-- 简答 -->
    <template v-if="questionItem.questionType == 5">
      <div class="q-content">
        <template v-if="action === 'do'">
          <van-field v-model="questionItem.correct"
                     class="textarea-box"
                     type="textarea"
                     rows="5"
                     :border="true"
                     placeholder="请输入"
                     style="margin-top: 10px;"></van-field>
        </template>
        <template v-else>
          <van-field v-model="questionItem.answer.stuAnswer"
                     class="textarea-box"
                     type="textarea"
                     rows="6"
                     :border="true"
                     placeholder="请输入"
                     style="margin-top: 10px;"
                     disabled></van-field>
        </template>
      </div>
    </template>
    <!-- 题型 END -->

    <!-- 题目信息 -->
    <div class="q-info"
         v-if="action === 'view'">
      <div class="answer-result"
           :class="questionItem.answer.answerResult == 1?'text-green':'text-danger'">
        <span>答题结果：</span>
        <span>{{questionItem.answer.answerResult == 1?'正确':'错误'}}</span>
      </div>
      <!-- <div class="q-info-item"><span class="info-tit">分数：</span>{{questionItem.scoreStr}}分</div> -->
      <div class="q-info-item"><span class="info-tit">标签：</span>{{questionItem.questionTagNm}}</div>
      <div class="q-info-item"><span class="info-tit">所属题库：</span>{{questionItem.bankName}}</div>
      <div class="q-info-item border">
        <span class="info-tit text-green">标准答案：</span>
        <!-- 非填空题答案显示框 -->
        <div class="html-box"
             v-html="questionItem.correct"
             v-if="questionItem.questionType != 4"></div>
        <!-- 填空题答案显示框 -->
        <div class="html-box"
             v-else>
          <span v-for="(item,index) in questionItem.correctArray"
                :key="index">{{index+1}}. <span v-html="item"></span><br /></span>
        </div>
      </div>
      <div class="q-info-item border">
        <span class="info-tit text-green">解析：</span>
        <div class="html-box"
             v-html="questionItem.analyze"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionExam',
  props: {
    questionItem: {
      type: Object,
      default: () => { }
    },
    action: {
      type: String,
      default: 'do' // view：查看，do：考试
    }
  },
  computed: {
    answerResultClass() {
      return function (questionItem) {
        if (!questionItem.answer) {
          return ''
        }
        if (questionItem.answer.answerResult == 1) {
          return 'right'
        } else if (questionItem.answer.answerResult == 2) {
          return 'wrong'
        } else {
          return ''
        }
      }
    }
  },
  methods: {},
}
</script>

<style lang="less" scoped>
::v-deep .q-title {
  position: relative;
  font-size: 14px;
  background-color: #f8f8f8;
  overflow: hidden;
  padding: 8px;
  &.right {
    background-color: #cceebc;
  }
  &.wrong {
    background-color: #ffbfbf;
  }
  .title-text {
    color: #1989fa;
    margin-right: 6px;
  }
  p {
    margin: 5px 0;
  }
}

.q-content {
  ::v-deep .van-radio,
  .van-checkbox {
    display: flex;
    align-items: center;
    margin-top: 12px;
    width: 100%;
  }
  .inp-box {
    margin-top: 10px;
    margin-bottom: 10px;
    ::v-deep .van-cell {
      .van-cell__title {
        width: 20px;
      }
    }
  }
  .textarea-box {
    border: 1px solid #eee;
  }
  ::v-deep .q-item-span-content p {
    display: inline;
    margin: 0;
  }
}
.q-info {
  border-top: 1px dashed red;
  line-height: 1.5;
  margin-top: 16px;
  .q-info-item {
    margin-top: 10px;
    .info-tit {
      font-weight: 800;
    }
    .html-box {
      border: 1px dashed #e0e0e0;
      padding: 10px;
      ::v-deep p {
        margin: 0;
      }
    }
  }
  .answer-result {
    margin-top: 10px;
    font-size: 14px;
    text-align: center;
    font-weight: 600;
  }
}
</style>
<style>
.gapfilling-span {
  color: red;
  padding: 0 30px;
  margin: 0 5px;
  border-bottom: 2px solid red;
}
</style>